export default __webpack_public_path__ + "static/media/token-hypr.47623524.png";